import { createSelector } from '@reduxjs/toolkit';
import { getAllDevicesIdsOnGroupsByGroupIdPropSelector } from '../../groups/selectors';
import { getMyIncidentsSelector } from './getMyIncidentsSelector';

export interface getAlarmsBySelectorProps {
  // Encoded group id
  groupId?: string;
  // Encoded device id
  deviceId?: string;
  controlUnitId?: string;
  filterByActive?: boolean;
}

/**
 * Get alarms filter by
 * All devices inside of a Group if is a groupId is passed
 * Device if is a deviceId is passed
 * CU if is a cuId and deviceId is passed
 */
export const getAlarmBySelector = createSelector(
  [
    (state: any, props: getAlarmsBySelectorProps) => props.groupId,
    (state: any, props: getAlarmsBySelectorProps) => props.deviceId,
    (state: any, props: getAlarmsBySelectorProps) => props.controlUnitId,
    getAllDevicesIdsOnGroupsByGroupIdPropSelector,
    getMyIncidentsSelector,
  ],
  (groupId, deviceId, cuId, devicesIdInGroup, incidentsDataResponse) => {
    const { data: incidentsData = [], ...other } = incidentsDataResponse;
    const filterAlarms = incidentsData.filter((incident) => {
      if (cuId && deviceId) {
        return incident.deviceId === deviceId && `${incident.cu}` === cuId;
      }
      if (deviceId) {
        return incident.deviceId === deviceId;
      }
      if (groupId) {
        return devicesIdInGroup.includes(incident.deviceId);
      }

      return true;
    });
    return { data: filterAlarms, ...other };
  }
);
